export const mockProjects = [
  {
    id: "1",
    title: "Girls Education Initiative",
    category: "Education",
    description: "Providing scholarships, school supplies, and safe learning environments for girls in Kabul and Kandahar provinces.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20girls%20studying%20in%20a%20bright%20classroom%20with%20books%20and%20colorful%20supplies%2C%20warm%20natural%20lighting%2C%20hopeful%20atmosphere%2C%20clean%20simple%20background&width=800&height=500&seq=proj1&orientation=landscape",
    raised: 48200,
    goal: 60000,
    status: "active",
    location: "Kabul & Kandahar",
    beneficiaries: 320,
  },
  {
    id: "2",
    title: "Clean Water Access Program",
    category: "Infrastructure",
    description: "Installing water purification systems and wells in rural Afghan villages to provide clean drinking water to thousands of families.",
    image: "https://readdy.ai/api/search-image?query=Clean%20water%20well%20installation%20in%20a%20rural%20Afghan%20village%2C%20community%20members%20gathering%2C%20bright%20sunny%20day%2C%20simple%20background&width=800&height=500&seq=proj2&orientation=landscape",
    raised: 31500,
    goal: 45000,
    status: "active",
    location: "Helmand Province",
    beneficiaries: 1200,
  },
  {
    id: "3",
    title: "Mobile Health Clinics",
    category: "Healthcare",
    description: "Deploying mobile medical units staffed by volunteer doctors to provide primary healthcare in underserved communities.",
    image: "https://readdy.ai/api/search-image?query=Mobile%20medical%20clinic%20in%20Afghanistan%2C%20doctor%20treating%20patients%20outdoors%2C%20clean%20white%20medical%20tent%2C%20warm%20compassionate%20atmosphere&width=800&height=500&seq=proj3&orientation=landscape",
    raised: 22800,
    goal: 35000,
    status: "active",
    location: "Nangarhar Province",
    beneficiaries: 850,
  },
  {
    id: "4",
    title: "Vocational Training Centers",
    category: "Education",
    description: "Teaching marketable skills — tailoring, carpentry, IT, and agriculture — to unemployed youth and women.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20youth%20learning%20vocational%20skills%20in%20a%20training%20workshop%2C%20sewing%20machines%20and%20tools%2C%20focused%20students%2C%20bright%20indoor%20setting&width=800&height=500&seq=proj4&orientation=landscape",
    raised: 18900,
    goal: 28000,
    status: "active",
    location: "Herat",
    beneficiaries: 210,
  },
  {
    id: "5",
    title: "Refugee Resettlement Support",
    category: "Community",
    description: "Helping Afghan refugee families in Canada integrate through language classes, housing assistance, and employment guidance.",
    image: "https://readdy.ai/api/search-image?query=Afghan%20refugee%20family%20in%20Canada%20receiving%20community%20support%2C%20warm%20welcoming%20environment%2C%20multicultural%20setting%2C%20hopeful%20expressions&width=800&height=500&seq=proj5&orientation=landscape",
    raised: 55000,
    goal: 55000,
    status: "completed",
    location: "Toronto & Ottawa",
    beneficiaries: 480,
  },
  {
    id: "6",
    title: "Winter Relief Campaign",
    category: "Humanitarian",
    description: "Distributing warm clothing, blankets, and food packages to vulnerable families during harsh Afghan winters.",
    image: "https://readdy.ai/api/search-image?query=Humanitarian%20aid%20distribution%20in%20Afghanistan%2C%20volunteers%20handing%20out%20warm%20blankets%20and%20food%20packages%20to%20families%20in%20winter%2C%20compassionate%20scene&width=800&height=500&seq=proj6&orientation=landscape",
    raised: 12400,
    goal: 20000,
    status: "active",
    location: "Multiple Provinces",
    beneficiaries: 600,
  },
];

export const mockStats = [
  { label: "Students Supported", value: "2,500+" },
  { label: "Active Projects", value: "15" },
  { label: "Years of Impact", value: "8" },
  { label: "Volunteers", value: "340+" },
];
